import React from "react"
import { Type } from "react-bootstrap-table2-editor"

const bulkPlacesListColumns = removePlaceFromList => {
  const headerStyle = { verticalAlign: "middle" }
  const textFormatterStyle = {
    display: "block",
    width: "120px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  }
  const editorStyle = {
    border: "none",
    borderBottom: "1px solid",
    width: "120px",
    padding: "0px",
  }
  return [
    {
      text: "id",
      dataField: "id",
      hidden: true,
    },
    {
      dataField: "name",
      text: "Name*",
      formatter: (col, row) => {
        return (
          <span style={{ ...textFormatterStyle, width: "100px" }}>{col}</span>
        )
      },
      headerStyle: () => {
        return headerStyle
      },
      validator: newValue => {
        if (!newValue) {
          return {
            valid: false,
            message: "The name is required!",
          }
        }
        return true
      },
      editorStyle: () => {
        return { ...editorStyle, width: "100px" }
      },
    },
    {
      dataField: "details",
      text: "Details",
      headerStyle: () => {
        return headerStyle
      },
      formatter: (col, row) => {
        return (
          <span style={{ ...textFormatterStyle, width: "100px" }}>{col}</span>
        )
      },
      editorStyle: () => {
        return { ...editorStyle, width: "100px" }
      },
    },
    {
      dataField: "hours",
      text: "Hours",
      headerStyle: () => {
        return headerStyle
      },
      formatter: (col, row) => {
        return <span style={textFormatterStyle}>{col}</span>
      },
      editorStyle: () => {
        return editorStyle
      },
    },
    {
      dataField: "address_street_1",
      text: "Address Street 1*",
      headerStyle: () => {
        return headerStyle
      },
      validator: (newValue, row, column) => {
        if (!newValue) {
          return {
            valid: false,
            message: "The address is required!",
          }
        }
        return true
      },
      formatter: (col, row) => {
        return <span style={textFormatterStyle}>{col}</span>
      },
      editorStyle: () => {
        return editorStyle
      },
    },
    {
      dataField: "address_street_2",
      text: "Address Street 2",
      headerStyle: () => {
        return headerStyle
      },
      formatter: (col, row) => {
        return <span style={textFormatterStyle}>{col}</span>
      },
      editorStyle: () => {
        return editorStyle
      },
    },
    {
      dataField: "city",
      text: "City*",
      headerStyle: () => {
        return headerStyle
      },
      validator: (newValue, row, column) => {
        if (!newValue) {
          return {
            valid: false,
            message: "The city is required!",
          }
        }
        return true
      },
      formatter: (col, row) => {
        return (
          <span style={{ ...textFormatterStyle, width: "80px" }}>{col}</span>
        )
      },
      editorStyle: () => {
        return { ...editorStyle, width: "80px" }
      },
    },
    {
      dataField: "state",
      text: "State*",
      headerStyle: () => {
        return headerStyle
      },
      validator: (newValue, row, column) => {
        if (!newValue) {
          return {
            valid: false,
            message: "The state is required!",
          }
        }
        return true
      },
      formatter: (col, row) => {
        return (
          <span style={{ ...textFormatterStyle, width: "50px" }}>{col}</span>
        )
      },
      editorStyle: () => {
        return { ...editorStyle, width: "50px" }
      },
    },
    {
      dataField: "zip_code",
      text: "Zip Code",
      headerStyle: () => {
        return headerStyle
      },
      formatter: (col, row) => {
        return (
          <span style={{ ...textFormatterStyle, width: "80px" }}>{col}</span>
        )
      },
      editorStyle: () => {
        return { ...editorStyle, width: "80px" }
      },
    },
    {
      dataField: "country_code",
      text: "Country Code",
      headerStyle: () => {
        return headerStyle
      },
      formatter: (col, row) => {
        return (
          <span style={{ ...textFormatterStyle, width: "100px" }}>{col}</span>
        )
      },
      editorStyle: () => {
        return { ...editorStyle, width: "100px" }
      },
    },
    {
      dataField: "lat",
      text: "Latitude",
      headerStyle: () => {
        return headerStyle
      },
      formatter: (cellContent, row) => (
        <span style={{ ...textFormatterStyle, width: "60px" }}>
          {cellContent && parseFloat(cellContent).toFixed(3)}
        </span>
      ),
      validator: (newValue, row, column) => {
        if (isNaN(newValue)) {
          return {
            valid: false,
            message: "Latitude should be numeric",
          }
        }
        return true
      },
      editorStyle: () => {
        return { ...editorStyle, width: "60px" }
      },
    },
    {
      dataField: "lon",
      text: "Longitude",
      headerStyle: () => {
        return headerStyle
      },
      formatter: (cellContent, row) => (
        <span style={{ ...textFormatterStyle, width: "60px" }}>
          {cellContent && parseFloat(cellContent).toFixed(3)}
        </span>
      ),
      validator: (newValue, row, column) => {
        if (isNaN(newValue)) {
          return {
            valid: false,
            message: "Longitude should be numeric",
          }
        }
        return true
      },
      editorStyle: () => {
        return { ...editorStyle, width: "60px" }
      },
    },
    {
      dataField: "category",
      text: "Category",
      headerStyle: () => {
        return headerStyle
      },
      formatter: (col, row) => {
        return (
          <span style={{ ...textFormatterStyle, width: "80px" }}>{col}</span>
        )
      },
      editorStyle: () => {
        return { ...editorStyle, width: "80px" }
      },
    },
    {
      dataField: "handicap_access",
      text: "Handicap Access",
      headerStyle: () => {
        return { width: "40px", textAlign: "center" }
      },
      editor: {
        type: Type.CHECKBOX,
        value: "1:0",
      },
      formatter: (cellContent, row) => (
        <input
          type="checkbox"
          checked={cellContent === "1"}
          onChange={() => {}}
          style={{
            display: "block",
            width: "40px",
          }}
        />
      ),
      editorStyle: () => {
        return { ...editorStyle, width: "40px" }
      },
    },
    {
      dataField: "starred",
      text: "Starred",
      headerStyle: () => {
        return headerStyle
      },
      editor: {
        type: Type.CHECKBOX,
        value: "1:0",
      },
      formatter: (cellContent, row) => (
        <input
          type="checkbox"
          checked={cellContent === "1"}
          onChange={() => {}}
          style={{
            display: "block",
            width: "40px",
          }}
        />
      ),
      editorStyle: () => {
        return { ...editorStyle, width: "40px" }
      },
    },
    {
      dataField: "delete",
      text: "Starred",
      isDummyField: true,
      headerStyle: () => {
        return { display: "none" }
      },
      editable: false,
      formatter: (cellContent, row) => (
        <i
          className="bx bx-sm bx-x"
          style={{
            cursor: "pointer",
            color: "red",
          }}
          onClick={() => {
            removePlaceFromList(row)
          }}
        />
      ),
    },
  ]
}

export default bulkPlacesListColumns
